import script from "./DescriptionGeneratorsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionGeneratorsView.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionGeneratorsView.vue?vue&type=style&index=0&id=5f081616&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f081616"]])

export default __exports__